import React from "react";
import style from "../style/input.module.css";
import { maskMoney } from "../function/funcionalidades";

export default function Input({ mask, valor, inputMask, placeholder, id }) {
  function handleMask(text) {
    if (mask === "currency") {
      inputMask(maskMoney(text));
    } else {
      inputMask(text);
    }
  }

  return (
    <input
      type="text"
      id={id}
      placeholder={placeholder}
      value={valor}
      onChange={(e) => handleMask(e.target.value)}
      className={style.input}
    />
  );
}
